var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"data-cy":"router-back-btn","icon":"","fab":"","small":""},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',{staticClass:"blue-grey--text text--lighten-2"},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }